export const TAG_COLOR_LIST = [
  {
    label: "Alternative",
    color: "#A50032",
  },
  {
    label: "Cash",
    color: "#518428",
  },
  {
    label: "Equity",
    color: "#1F55A5",
  },
  {
    label: "Fixed Income",
    color: "#EF7622",
  },
  {
    label: "Not Classified",
    color: "#E5E5E5",
  },
  {
    label: "Allocation",
    color: "#E6C235",
  },
  {
    label: "Index",
    color: "#000",
  },
];
